import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { DropdownMenuComponent } from '../dropdown-menu.component';

@Component({
  selector: 'rcp-dropdown-menu-item',
  styles: `
    .rcp-dropdown-menu-item {
      height: var(--item-height-md);
      padding: var(--item-padding-md);
      background: var(--col-bg-base);
      color: var(--col-text-primary);
      transition:
        background-color 0.3s,
        color 0.3s;
      cursor: pointer;
      display: flex;
      align-items: center;
      border-radius: var(--br);

      &:hover:not(.disabled) {
        background: var(--col-active);
        color: white;
      }

      &.disabled {
        cursor: default;
        color: var(--col-disabled-contrast);
        background: var(--col-disabled-base);
      }

      .item-content {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
      }

      .item-icon {
        flex: 0 0 auto;
        width: 24px;
        text-align: center;
      }
    }
  `,
  template: `
    <div class="rcp-dropdown-menu-item" (click)="closeDropdownMenu($event)" [class.disabled]="disabled()">
      @if (icon()) {
        <div class="item-icon">
          <fa-icon [icon]="icon()"></fa-icon>
        </div>
      }

      <div class="item-content ellipsis">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  imports: [FaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuItemComponent {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  private dropdownMenu = inject(DropdownMenuComponent, { optional: true })!;

  readonly icon = input<IconProp>();
  readonly disabled = input<boolean>(false);
  readonly preventClose = input<boolean>(false);

  closeDropdownMenu($event: MouseEvent) {
    if (this.disabled()) {
      $event.preventDefault();
      $event.stopPropagation();

      return;
    }

    if (!this.preventClose()) {
      this.dropdownMenu.hide();
    }
  }
}
